import React from 'react';
import './WidgetOptons.css';


function WidgetOptons() {
    return (
        <div className='widgetOptions'>
            <div className='widget_content'>
                <img src='http://drive.google.com/uc?export=view&id=1zggzvGp3v8UvVXxea2F8bYBAQ3G1MkRJ' alt="롤스로이스"/>
                <div className='widget_contentTitle'>
                    <h5>CIT No.1</h5>
                    <p> 리액트를 공부하는 CIT </p>
                </div>

            </div>
            <div className='widget_content'>
                <img src='http://drive.google.com/uc?export=view&id=1zggzvGp3v8UvVXxea2F8bYBAQ3G1MkRJ' alt="롤스로이스"/>
                <div className='widget_contentTitle'>
                    <h5>CIT No.1</h5>
                    <p> 리액트를 공부하는 CIT </p>
                </div>

            </div>
            <div className='widget_content'>
                <img src='http://drive.google.com/uc?export=view&id=1zggzvGp3v8UvVXxea2F8bYBAQ3G1MkRJ' alt="롤스로이스"/>
                <div className='widget_contentTitle'>
                    <h5>CIT No.1</h5>
                    <p> 리액트를 공부하는 CIT </p>
                </div>

            </div>
            <div className='widget_content'>
                <img src='http://drive.google.com/uc?export=view&id=1zggzvGp3v8UvVXxea2F8bYBAQ3G1MkRJ' alt="롤스로이스"/>
                <div className='widget_contentTitle'>
                    <h5>CIT No.1</h5>
                    <p> 리액트를 공부하는 CIT </p>
                </div>

            </div>
            <div className='widget_content'>
                <img src='http://drive.google.com/uc?export=view&id=1zggzvGp3v8UvVXxea2F8bYBAQ3G1MkRJ' alt="롤스로이스"/>
                <div className='widget_contentTitle'>
                    <h5>CIT No.1</h5>
                    <p> 리액트를 공부하는 CIT </p>
                </div>

            </div>
            <div className='widget_content'>
                <img src='http://drive.google.com/uc?export=view&id=1zggzvGp3v8UvVXxea2F8bYBAQ3G1MkRJ' alt="롤스로이스"/>
                <div className='widget_contentTitle'>
                    <h5>CIT No.1</h5>
                    <p> 리액트를 공부하는 CIT </p>
                </div>

            </div>
            <div className='widget_content'>
                <img src='http://drive.google.com/uc?export=view&id=1zggzvGp3v8UvVXxea2F8bYBAQ3G1MkRJ' alt="롤스로이스"/>
                <div className='widget_contentTitle'>
                    <h5>CIT No.1</h5>
                    <p> 리액트를 공부하는 CIT </p>
                </div>

            </div>
            

        </div>
    )
}

export default WidgetOptons;